
import './style/App.scss'

import REact,{useState} from 'react'
import Scene from './screen/Scene'
import Navbar from './components/Navbar'
// import Alien from './components/Alien';


function App() {
  const [showFaces, setShowFaces] = useState(false)

  
  return (
    <div className='App'>
      <Scene showFaces={showFaces} setShowFaces={setShowFaces} />
    </div>
  )
}

export default App
